<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading">
    <v-card-title>Questions</v-card-title>
    <v-card-text v-if="!currentLeadLoading">
      <v-row>
        <v-col>
          <template v-if="notEmpty(currentLead.questions).length===0">
            <p>No questions to show</p>
          </template>
          <template v-else>
            <v-expansion-panels focusable>
              <template v-for="(item,itemi) in notEmpty(currentLead.questions)">
                <v-expansion-panel :key="itemi">
                  <v-expansion-panel-header>{{item[0]}}</v-expansion-panel-header>
                  <v-expansion-panel-content><br>{{item[1]}}</v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    computed: {
      ...mapState('leads', ['currentLead','currentLeadLoading']),
    },
    methods: {
      notEmpty(val) {
        return (val === null || val === "" || val === undefined)?[]:val;
      }
    },
  }
</script>

<style lang="scss" scoped></style>
